import React from "react";
import GAAddGroupContainer from "../../modules/GAGroups/containers/GAAddGroupContainer/GAAddGroupContainer";

const GAAddGroup = () => {
  return <GAAddGroupContainer />;
};

export default GAAddGroup;

